<template>
  <div v-if="currentPost == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar destacado</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
                <post-form :entity="currentPost" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import PostForm from "./PostForm";

    const store = useStore();
    const route = useRoute();

    const getCurrentPost = async (id) => {
      return await store.dispatch("post/getPostById", id);
    };

    const currentPost = computed(() => store.state.post.currentPost);

    onMounted(() => {
      getCurrentPost(route.params.id)
    });

</script>
